<div class="header-container">
  <div class="header-title-container">
    <div class="header-logo">
      <img
        src="../../assets/acc_logo.jpg"
        alt="Logo"
        class="logo-img"
        [routerLink]="['/device-dashboard']"
      />
    </div>
    <div class="header-main-title">
      <img
        loading="lazy"
        src="../../assets/header_icon.png"
        alt="Icon"
        class="header-icon"
      />
      <h6>AEPL {{ projectName }} {{ env }} Diagnostic Cloud</h6>
    </div>
  </div>
  <nav class="custom-navbar">
    <div
      class="hamburger-menu"
      (click)="toggleMenu()"
      (keydown.enter)="(0)"
      tabindex="0"
    >
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </div>
    <ul class="nav-list" [ngClass]="{ 'menu-active': isMenuOpen }">
      <li class="nav-item theme-nav-item">
        <button
          type="button"
          class="theme-toggle-button"
          (click)="toggleTheme()"
          [attr.aria-label]="
            currentTheme === 'light'
              ? 'Switch to dark theme'
              : 'Switch to light theme'
          "
          [title]="
            currentTheme === 'light'
              ? 'Switch to dark theme'
              : 'Switch to light theme'
          "
        >
          <mat-icon>{{
            currentTheme === 'light' ? 'dark_mode' : 'light_mode'
          }}</mat-icon>
        </button>
      </li>
      @if (DashboardTabView) {
        <li class="nav-item dropdown" [ngClass]="{ active: isDashboardActive }">
          <a
            href="javascript:;"
            class="dropdown-toggle"
            (click)="toggleDropdown('dashboard')"
            >Dashboard</a
          >
          <ul
            class="dropdown-content"
            [ngClass]="{ show: activeDropdown === 'dashboard' }"
          >
            @if (DeviceDashboardView) {
              <li [ngClass]="{ 'active-item': isDashboardNavItemActive }">
                <a (click)="toggleDropdown('')" routerLink="device-dashboard"
                  >Device Dashboard</a
                >
              </li>
            }
            @if (TicketDashboardView) {
              <li
                [ngClass]="{
                  'active-item': isTicketDashboardNavItemActive,
                }"
              >
                <a
                  (click)="toggleDropdown('')"
                  routerLink="ticket-dashboard-page"
                  >Ticket Dashboard</a
                >
              </li>
            }
          </ul>
        </li>
      }
      @if (DeviceUtilityTabView) {
        <li
          class="nav-item dropdown"
          [ngClass]="{ active: isDeviceUtilityActive }"
        >
          <a
            href="javascript:;"
            class="dropdown-toggle"
            (click)="toggleDropdown('deviceUtility')"
            >Device Utility</a
          >
          <ul
            class="dropdown-content"
            [ngClass]="{ show: activeDropdown === 'deviceUtility' }"
          >
            @if (MyActivationsView && projectName === 'TCU4G') {
              <li [ngClass]="{ 'active-item': isTicketListNavItemActive }">
                <a (click)="toggleDropdown('')" routerLink="ais140-ticket-list">
                  My AIS 140 Tickets
                </a>
              </li>
            }
            @if (GovernmentServersView) {
              <li
                [ngClass]="{
                  'active-item': isGovernmentServerNavItemActive,
                }"
              >
                <a (click)="toggleDropdown('')" routerLink="govt-servers"
                  >Government Servers</a
                >
              </li>
            }
            @if (DeviceFotaView) {
              <li [ngClass]="{ 'active-item': isFOTANavItemActive }">
                <a (click)="toggleDropdown('')" routerLink="fota-batch-list"
                  >FOTA</a
                >
              </li>
            }
            @if (DeviceOtaView) {
              <li [ngClass]="{ 'active-item': isOTANavItemActive }">
                <a (click)="toggleDropdown('')" routerLink="Ota-batch-list"
                  >OTA</a
                >
              </li>
            }
            @if (ModelView) {
              <li [ngClass]="{ 'active-item': isDeviceModelNavItemActive }">
                <a (click)="toggleDropdown('')" routerLink="device-model-list">
                  Device Models</a
                >
              </li>
            }
            @if (DealerFotaDashboardView && projectName === 'TCU4G') {
              <li [ngClass]="{ 'active-item': isDealerFOTANavItemActive }">
                <a (click)="toggleDropdown('')" routerLink="dealer-fota">
                  Dealer FOTA</a
                >
              </li>
            }
            @if (DispatchDeviceView) {
              <li [ngClass]="{ 'active-item': isDispatchDeviceNavItemActive }">
                <a
                  (click)="toggleDropdown('')"
                  routerLink="dispatch-device-list"
                >
                  Dispatch Device</a
                >
              </li>
            }
          </ul>
        </li>
      }
      @if (ReportsView) {
        <li class="nav-item dropdown" [ngClass]="{ active: isReportsActive }">
          <a
            href="javascript:;"
            class="dropdown-toggle"
            (click)="toggleDropdown('report')"
            >Reports</a
          >
          <ul
            class="dropdown-content"
            [ngClass]="{ show: activeDropdown === 'report' }"
          >
            @if (AIS140TicketTMLRequestLogsView && projectName === 'TCU4G') {
              <li [ngClass]="{ 'active-item': isAPIRequestLogsReportsActive }">
                <a
                  (click)="toggleDropdown('')"
                  routerLink="ais140-api-req-logs"
                >
                  AIS140 Ticket TML Request Logs
                </a>
              </li>
            }
            @if (AIS140TicketAEPLResponseLogsView && projectName === 'TCU4G') {
              <li
                [ngClass]="{
                  'active-item': isAPIResponseLogsReportsActive,
                }"
              >
                <a
                  (click)="toggleDropdown('')"
                  routerLink="ais140-api-res-logs"
                >
                  AIS140 Ticket AEPL Response Logs
                </a>
              </li>
            }
            @if (AIS140TicketStatusUpdateLogsView && projectName === 'TCU4G') {
              <li [ngClass]="{ 'active-item': isAPILogsReportsActive }">
                <a
                  (click)="toggleDropdown('')"
                  routerLink="ais140-tml-api-logs"
                >
                  AIS140 Ticket Status Update Logs
                </a>
              </li>
            }
            @if (SIMBatchDataDetailsView) {
              <li [ngClass]="{ 'active-item': isSIMDataReportsActive }">
                <a (click)="toggleDropdown('')" routerLink="sim-data-details">
                  SIM Data Details
                </a>
              </li>
            }
            @if (DeviceStateConfigView) {
              <li [ngClass]="{ 'active-item': isDeviceStateConfigActive }">
                <a
                  (click)="toggleDropdown('')"
                  routerLink="device-state-config"
                >
                  Device State Config
                </a>
              </li>
            }
            @if (DeviceVinConfigView) {
              <li [ngClass]="{ 'active-item': isDeviceVinConfigActive }">
                <a (click)="toggleDropdown('')" routerLink="device-vin-config">
                  Device Vin Config
                </a>
              </li>
            }
            @if (DeviceSystemActivityLogView) {
              <li
                [ngClass]="{ 'active-item': isDeviceSystemActivityLogActive }"
              >
                <a
                  (click)="toggleDropdown('')"
                  routerLink="device-system-activity-log"
                >
                  Device System Activity Log
                </a>
              </li>
            }
          </ul>
        </li>
      }
      @if (UserView) {
        <li
          class="nav-item dropdown"
          [ngClass]="{ active: isUserManagementActive }"
        >
          <a
            href="javascript:;"
            class="dropdown-toggle"
            (click)="toggleDropdown('user')"
            >User</a
          >
          <ul
            class="dropdown-content"
            [ngClass]="{ show: activeDropdown === 'user' }"
          >
            @if (UserManagementView) {
              <li [ngClass]="{ 'active-item': isUserTabActive }">
                <a (click)="toggleDropdown('')" routerLink="user-management">
                  User Management
                </a>
              </li>
            }
            @if (roleType === 'SA') {
              <li [ngClass]="{ 'active-item': isUserRoleActive }">
                <a (click)="toggleDropdown('')" routerLink="role-management">
                  Role Management
                </a>
              </li>
            }
            @if (roleType === 'SA') {
              <li [ngClass]="{ 'active-item': isGroupManagementActive }">
                <a (click)="toggleDropdown('')" routerLink="group-management">
                  Group Management
                </a>
              </li>
            }
          </ul>
        </li>
      }
      <li class="nav-item dropdown" [ngClass]="{ active: isProfileActive }">
        <a
          href="javascript:;"
          class="dropdown-toggle"
          (click)="toggleDropdown('profile')"
        >
          <!-- <mat-icon matPrefix>person</mat-icon> -->
          <span>
            Hi,
            {{
              userName
                ? userName.length > 9
                  ? userName.substring(0, 9)
                  : userName
                : '--'
            }}</span
          >
        </a>
        <ul
          class="dropdown-content"
          [ngClass]="{ show: activeDropdown === 'profile' }"
        >
          @if (ProfileView) {
            <li [ngClass]="{ 'active-item': isProfileActive }">
              <a (click)="toggleDropdown('')" routerLink="profile">Profile</a>
            </li>
          }
          <li>
            <a class="dropdown-item" (click)="logout()" href="#">Log Out</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</div>
